import { render } from 'preact';
import { HowToVideosPage } from '../how-to-videos/HowToVideosPage.jsx';
import '../styles/how-to-videos.css';

const root = document.getElementById('pp-how-to-root');

if (root) {
  render(<HowToVideosPage />, root);
}
